module.exports = __webpack_public_path__ + "img/arrow-right.37a0dac1.svg";